// var options = [
//     {
//         type: 'liveList',
//         title : '图文直播'
//     },
//     {
//         type: 'liveSurvey',
//         title : '调查'
//     },
//     {
//         type: 'action',
//         title : '互动参与'
//     }
// ];

require('./tabTitle.css');
var tmpl = require('./tabTitle.ejs');

// require('./stycss');
// var tmpl = require('./main.ejs');
var util = require('f.core.mobile.util');
var Events = require('f.core.event')//.default;

var Tab = function(options) {
    this.container = options.container;
    this.tabs = [];
    this.index = 0;
    this.init();
};

Tab.prototype.init = function() {
    this.initDom();
    this.initEvent();
    //  this.initEvent();
};

Tab.prototype.initDom = function() {
    this.elhead = this.container.querySelector('.other-news-tit'); //图文选项表头
    this.elhead.innerHTML = tmpl({});
    this.elnav = this.elhead.querySelector('.option'); //导航切换标签
    this.elsort = this.elhead.querySelector('.sort'); //排序按钮
    this.elrefresh = this.elhead.querySelector('.refresh'); //刷新按钮
    this.eltuwen = this.container.querySelector('#tuwen'); //图文列表
    this.elrecommend = this.container.querySelector('#recommend'); //相关推荐
};

Tab.prototype.initEvent = function() {
    var contorlDom = $('.navbox');
    $('#js_sort').on('mouseover', function() {
        $(this).addClass('sort_on');
    });
    $('#js_sort').on('mouseout', function() {
        $(this).removeClass('sort_on');
    });
    $('#js_refresh').on('mouseover', function() {
        $(this).addClass('refresh_on');
    });
    $('#js_refresh').on('mouseout', function() {
        $(this).removeClass('refresh_on');
    });
    //     var tabTitlte = $('.c-tab__List').children();
    //     var tabContent = $('.c-tab__item');
    //     var tablen = tabTitlte.length;
    //
    //     for (var i=0;i<tablen;i++){
    //         tabTitlte[i].onclick = function () {
    //             for (var i=0;i<tablen;i++){
    //                 if(index == i) {
    //                     tabContent[i].style.display = 'block';
    //                     $(tabTitlte[i]).addClass('clicked');
    //                 }else{
    //                     tabContent[i].style.display = 'none';
    //                     $(tabTitlte[i]).removeClass('clicked');
    //                 }
    //             }
    //         }
    //     }
    //     util.tap(this.elHead, function (e) {
    //         var target = e.target;
    //         if (target.classList.contains('.c-nav__title--active')) {
    //             return;
    //         }
    //         var index = target.dataset.index;
    //         this.active(index);
    //     }, {
    //         scope: this,
    //         delegate: '.c-nav__title'
    //     });
};

Tab.prototype.add = function(title, compontent, callback) {
    callback = callback || function() {};
    var index = this.tabs.length;
    this.tabs.push({ tile: title, compontent: compontent, callback: callback });

    var tab = document.createElement('li');
    tab.classList.add('c-nav__title');
    if (this.tabs.length == 1) {
        tab.classList.add('c-nav__title--active');
    }
    tab.innerHTML = title;
    if(tab.dataset){
        tab.dataset.index = index;
    }else{
        tab.setAttribute('data-index',index)
    }
    this.elnav.appendChild(tab);//初始化第一个标签

    var item = document.createElement('div');
    item.classList.add('c-slider__item');

    compontent.renderTo($(item));

    if(item.dataset){
        item.dataset.index = index;
    }else{
        item.setAttribute('data-index',index)
    }

    this.eltuwen.appendChild(item);
};

Tab.prototype.active = function(index) {
    var activeHead = this.elhead.querySelector('.c-nav__title--active');
    if (activeHead) {
        activeHead.classList.remove('c-nav__title--active');
    }
    this.elhead.querySelectorAll('.c-nav__title')[index].classList.add('c-nav__title--active');
    var activeItem = this.eltuwen.querySelector('.c-slider__item--active');
    if (activeItem) {
        activeItem.classList.remove('c-slider__item--active');
    }
    this.eltuwen.querySelectorAll('.c-slider__item')[index].classList.add('c-slider__item--active');
    this.tabs[index].callback(this.tabs[index].compontent);
};

Events.mixTo(Tab);

module.exports = Tab;

//
//
// module.exports = function (options) {
//     return temp(options);
// };



// WEBPACK FOOTER //
// ./app/modules/tab/index.js